import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const useLanguage = () => {
	return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }) => {
    const [languageOpen, setLanguageOpen] = useState(false);
	const [selectedLanguage, setSelectedLanguage] = useState("english"); // Lingua predefinita

	const toggleLanguage = () => {
		setLanguageOpen(!languageOpen);
	};

	const handleLanguageChange = (language) => {
		setSelectedLanguage(language);
		setLanguageOpen(false);
	};

	const languageContextValue = {
		selectedLanguage,
        languageOpen,
		toggleLanguage,
        handleLanguageChange,
	};

	return (
		<LanguageContext.Provider value={languageContextValue}>
			{children}
		</LanguageContext.Provider>
	);
};
